module.exports = __webpack_public_path__ + "fonts/Roboto-Light.82fabc8.eot";